<template>
  <b-container id="navbar" fluid class="border-bottom mb-3">
    <b-navbar variant="faded" type="light" class="py-3">
      <b-navbar-brand
        tag="h2"
        class="mb-0"
        style="cursor: pointer"
        v-on:click="$emit('click')"
        >Rendez-vous en ligne</b-navbar-brand
      >
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right noCaret>
          <template #button-content><span class="d-none d-sm-inline-block">Besoin d'aide ?</span><font-awesome-icon :icon="['fad', 'question-circle']" size="lg" class="d-sm-none" /></template>
          <div class='px-2 besoin-aide text-center' v-html="help"></div>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
  </b-container>
</template>

<script>
export default {
  name: "Navbar",

  computed: {
    help() {
      return this.$root.slugData.help ?? '';
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
